import { useTranslation } from 'react-i18next';

export const keyPrefix = 'goToCard';
export const useGoToCardTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Карточка',
  },
}) as Record<string, unknown>;
export const en = ({
  [keyPrefix]: {
    title: 'Card',
  },
}) as Record<string, unknown>;
export const ptBr = ({
  [keyPrefix]: {
    title: 'Cartão',
  },
}) as Record<string, unknown>;
export const esEs = ({
  [keyPrefix]: {
    title: 'Tarjeta',
  },
}) as Record<string, unknown>;
